<button-with-text-menu-arrow
  [item]="inputTime.itemConfiguration"
  [list]="inputTime.listHours"
  [selectedOption]="inputTime.selectedTime"
  [disabled]="disabled"
  (launchActionEmitter)="changeView($event.option)">
</button-with-text-menu-arrow>
